module.exports = __webpack_public_path__ + "static/media/app-store.7f7d3df9.webp";